import { Modal } from '@mantine/core';
import { IS_STORYBOOK } from '@repo/common/utils/envs';
import { observer } from 'mobx-react-lite';
import { type ReactNode } from 'react';
import { useLineageFlowFilterContext } from '../../context/LineageFlowProvider/LineageFlowContext';

interface LineageFlowContainerProps {
	isFullscreen: boolean;
	isERD?: boolean;
	exitFullscreen: () => void;
	children: ReactNode;
}

function LineageFlowContainer({
	isFullscreen,
	isERD = false,
	exitFullscreen,
	children,
}: LineageFlowContainerProps) {
	const { catalogFilter } = useLineageFlowFilterContext();

	// If the catalog filter has not been initialized, return null
	if (!catalogFilter && !isERD && !IS_STORYBOOK) {
		return null;
	}

	if (isFullscreen) {
		return (
			<Modal.Root opened onClose={exitFullscreen} fullScreen>
				<Modal.Content>{children}</Modal.Content>
			</Modal.Root>
		);
	}

	// eslint-disable-next-line react/jsx-no-useless-fragment
	return <>{children}</>;
}

const ObservedLineageFlowContainer = observer(LineageFlowContainer);
export default ObservedLineageFlowContainer;
